<template>

	<div class="contentPoolContent">

	    <!-- show loading indicator -->
		<loading-indicator :loading="isLoading"></loading-indicator>

	    <template v-if="!isLoading">

	        <!-- page-heading -->
	        <page-heading :show="true" :pageTitle="pageTitle"></page-heading>

	        <div class="columns">

	            <div class="col-main">

								<ul class="tabNav">

			            <li :class="[ {'is-active': activeTab=='OVERVIEW'}, 'item']" @click.prevent="setActiveTab('OVERVIEW')">
			                <a><lang labelKey="CPC-TAB-OVERVIEW"></lang></a>
			            </li>

									<template v-for="(variant, index) in articleVariantTypes" v-if="showVariant(variant)">
										<li :class="[ {'is-active': activeTab == variant.name}, { 'is-disabled': isAddingVariant || content.variants.filter(e => e.type.name === variant.name).length == 0}, 'item']" @click.prevent="setActiveTab(variant.name)">
			                  <a><lang :labelKey="'CPC-TAB-'+variant.name"></lang></a>
			              </li>
									</template>

			          </ul>

          <div class="tabContent">

						<template v-if="activeTab == 'OVERVIEW'">

							<content-pool-content-overview
								:content.sync="content"
								:categories="categories"
								:topics="topics" :contentTopics="contentTopics"
								:contentCategories="contentCategories"
								:isSaving="isSaving"
								@createVariant="createVariant"
								@setContentTopics="contentTopics=$event"
								@setContentCategories="contentCategories=$event"
								@setActiveTab="setActiveTab($event)">
							</content-pool-content-overview>

						</template>

						<template v-else>

							<keep-alive>
								<content-pool-content-element :key="activeTab" :content="content" :variants="content.variants" :variant="content.variants[getVariantIndexByName(activeTab)]" :channels="channels" :users="users" @setActiveTab="activeTab=$event"></content-pool-content-element>
							</keep-alive>

						</template>

		            </div>

	            </div>

	            <div class="col-aside">

					<affix :offset="50">

						<custom-button type="blue" icon="icon-ak-speichern" name="CPC-BTN-SAVE" :loading="isSaving" @click.native="submitForm()"></custom-button>

						<template v-if="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) > -1">
							<custom-button type="dark" icon="icon-ak-entfernen" name="CPC-BTN-DELETE" @click.native="deleteContent()" :class="{ 'is-disabled': !activeUser.isAdminRole && !content.id }"></custom-button>
						</template>

					</affix>

          		</div>

	        </div>

	    </template>


	</div>

</template>


<script>
import contentPoolContentElement from './incl-contentPoolContentElement';
import contentPoolContentOverview from './incl-contentPoolContentOverview';

export default {

    name: 'contentPoolContent',

	components: {
		contentPoolContentElement,
		contentPoolContentOverview
	},

    data() {

        return {
          isLoading: false,
					isSaving: false,
					isAddingVariant: false,
					isHidden: false,
					content: {},
					isNewContent: false,
					users: [],
					channels: [],
					contentTopics: [],
					contentCategories: [],
					categories: [],
					topics: [],
					activeTab: 'OVERVIEW',
					userRoles: [],
        }
    },

	watch: {

		activeTab(val) {
			// console.log("val: ", val);
			// this.$router.replace(this.$route.path + '#' + val);
		}

	},

	updated() {


	},

	computed: {

		pageTitle() {
			return this.content.title == "" ? this.$t('CPC-HEADLINE-NEW_CONTENT') : this.content.title;
		},

		articleTypes() {
			return this.$store.getters.getTermsByTaxonomy('ARTICLE_TYPES');
		},

		articleVariantTypes() {
			return this.$store.getters.getTermsByTaxonomy('ARTICLE_VARIANT_TYPES');
		},

		articleVariantStatus() {
			return this.$store.getters.getTermsByTaxonomy('ARTICLE_VARIANT_STATUS');
		}

	},


	created() {

		// console.log("created @contentPoolContent.vue");

		// existing product - fetch the equipment ID from router
		if(this.$route.params.contentID && Number.isInteger(parseInt(this.$route.params.contentID)) ) {
			this.fetchData(this.$route.params.contentID);
		}

		// new product
		else
		{

			this.isNewContent = true;

			this.fetchMandatoryData();

			var d = new Date();
			var ISODate = d.toISOString();

			// create new equipment obj with default values
			this.content = {
				title: "",
				type: null,
				updated: ISODate,
				created: ISODate,
				createdBy: this.activeUser,
				thread: null,
				assets: [],
				categories: [],
				topics: [],
				publications: [],
				variants: []
			}

		}

	},

	mounted() {

		// console.log("url: ", window.location.hash.substr(1));

		if(this.$route.params.tab || window.location.hash.substr(1)) {
			this.activeTab = this.$route.params.tab || window.location.hash.substr(1);
		}


	},

	methods: {

		setActiveTab(variant) {

			this.activeTab = variant;
			location.hash = variant;

		},

		showVariant(variant) {

			if(['Administrator', 'Administrator JTM', 'Herba Chefredaktion', 'Herba Leitung'].indexOf(this.activeUser.userRole.name) > -1) {
				return true;
			}

			let v = this.content.variants[this.getVariantIndexByName(variant.name)];

			if(typeof v == 'undefined' || v.assignee == null) {
				return false;
			}

			return v.assignee.id == this.activeUser.id;

		},


		getVariantIndexByName(variantName) {

	 		return this.content.variants.findIndex(variant => variant.type && variant.type != null ? variant.type.name == variantName : false);

				// return obj.type && obj.type != null ? obj.type.name == variantName : false;
				// });

		},

		async createVariant(variant) {

			var self = this;

			// variant.isCreating = true;
			this.isAddingVariant = true;

			// console.log("create variant....: ", variant);
			var d = new Date();
			var ISODate = d.toISOString();

			// assign the default image to the teaser images
			var teaserImage = null;
			for(let i in this.content.assets) {
				if(this.content.assets[i].isDefault == true) {
					teaserImage = this.content.assets[i].asset;
				}
			}

			let assignee = this.activeUser;
			// assignee.customLabel = this.activeUser.person.fullName;
			assignee.customLabel = this.activeUser.person.lastname + ' ('+this.activeUser.userRole.name+')';


			var newVariant = {
				article: '',
				assignee: assignee,	//  #11387
				content: "",
				updated: ISODate,
				created: ISODate,
				createdBy: this.activeUser,
				headline: "",
				id: null,
				kicker: "",
				publications: [],
				status: this.articleVariantStatus.NEW,
				teaserImage: teaserImage,
				headerImage: teaserImage,
				thread: null,
				type: this.articleVariantTypes[variant.name]
			}

			// we already got a content id
			if(this.content.id) {

				newVariant.article = self.content.id;
				this.dbAddNewVariant(newVariant);

			// otherwise we've to save the content first
			} else {

				const res = await this.submitForm(true);

				if(res == false) {

					this.isAddingVariant = false;
					return false;

				} else {

					// assign the new content id to our new variant
					newVariant.article = res.id;

					// and make a DB Save with the new variant ...
					await this.dbAddNewVariant(newVariant);

					await this.$router.replace( { name: 'complatContentPoolContent', hash: `#${newVariant.type.name }`, params: { 'contentID': res.id } });
					this.isAddingVariant = false;

				}


			}

		},


		async dbAddNewVariant(newVariant) {

			// console.log("dbAddNewVariant ...");

			this.content.variants.push(newVariant);
			var variantIndex = this.content.variants.length -1;

			// const response = await this.submitForm(true);

			this.getVariantChannels(this.articleVariantTypes[newVariant.type.name].data.channels).forEach((channel) => {

				let newObj = {
					channel: channel,
					articleVariant: this.content.variants[variantIndex].id
				}

				this.content.variants[variantIndex].publications.push(newObj);

				let pubIndex = this.content.variants[variantIndex].publications.length -1;

				channel.data.publicationFields.forEach((field) => {
					this.$set(this.content.variants[variantIndex].publications[pubIndex], field.field, null);
				});

			});


			// save
			await this.submitForm(true);

			this.isAddingVariant = false;

			await this.$nextTick();
			// set active Tab
			this.setActiveTab(newVariant.type.name);

		},

		getVariantChannels(variantChannels) {

			var self = this;
			var chs = [];

			variantChannels.forEach(function(channel) {
				chs.push(self.channels.find((ch) => ch.id == channel));
			})

			return chs;

		},



		submitForm(isSilent=false) {

			// console.log("submitting: ", this.content);

			/*
			// a global title must be set
			if(this.content.title == "") {
				this.$notify.open( {content: 'Bitte geben Sie mindestens einen internen Titel an!', type: 'warning'});#
				this.$set(variant, 'isCreating', true);
				return false;
			}
			*/

			if(this.activeTab != 'OVERVIEW' && this.content.variants && this.content.variants.length > 0) {

				// check if a "HerpaImuiplse Online" Variant is present
			 	let hiVariant = this.content.variants.find((v) => v.type.name == "HERBA_IMPULSE_ONLINE");

				if(hiVariant) {

					// date must be filled
					if(hiVariant.publications[0] && (hiVariant.publications[0].startDate == "" || hiVariant.publications[0].startDate == null)) {
						this.$notify.open( {content: 'Bitte geben ein Datum für "Online ab" ein', type: 'warning'});
						return false;
					}
					// headline must be filled
					if(hiVariant.headline == "") {
						this.$notify.open( {content: 'Bitte geben Sie eine Headline ein!', type: 'warning'});
						return false;
					}
					// content must be filled
					if(!hiVariant.content || hiVariant.content == "") {
						this.$notify.open( {content: 'Bitte geben Sie einen Inhalt ein!', type: 'warning'});
						return false;
					}

				}
			}


			var self = this;

			return new Promise(function(resolve, reject) {

				self.isSaving = true;

				// prepare categories (date structure) before saving
				var cats = [];
				self.contentCategories.forEach((cat) => {
					let obj = {
						article: self.content.id,
						category: cat
					}
					cats.push(obj);
				});

				self.content.categories = cats;


				// prepare topics (data structure) before saving
				var topics = [];
				self.contentTopics.forEach(function(topic) {
					let obj = {
						article: self.content.id,
						topic: topic
					}
					topics.push(obj);
				});

				self.content.topics = topics;


				// remove updated and created fields
				delete self.content.updated;
				self.content.variants.forEach(function(variant) {
					delete variant.updated;
					delete variant.created;
				})


				self.entityCreateOrUpdate('article', self.content, { 'isSilent': isSilent })
					.then(response => {

						self.content.id = response.id;

						// assign updated and created fields
						self.content.updated = response.updated;
						self.content.created = response.created;

						self.content.variants.forEach((variant, index) => {
							let savedVariant = response.variants.find(va => va.type.name == variant.type.name );

							// console.log("savedVariant: ", savedVariant);
							// console.log("INDEX: ", index);

							self.$set(self.content.variants[index], 'id', savedVariant.id);
							self.$set(self.content.variants[index], 'updated', savedVariant.updated);
							self.$set(self.content.variants[index], 'created', savedVariant.created);
							self.$set(self.content.variants[index], 'friendlyName', savedVariant.friendlyName ? savedVariant.friendlyName : null);

						})

						// change the history (important when navigating away and then back)
						// self.$router.replace( { name: 'complatContentPoolContent', params: { 'contentID': response.id } });
						// self.$router.push( { name: 'complatContentPoolContent', params: { 'contentID': response.id } });

						self.isSaving = false;

						resolve(response);

					});

			});

		},

		deleteContent() {

			var self = this;
			this.entityDelete('article', this.content.id, 'CPC-CONFIRM_DELETION')
				.then(function(response) {
					self.$router.push({ name: 'complatContentPool'});
				}).catch(function(error) {
					console.log('Error: ', error.message);
				});

		},


		async fetchData(contentID) {

			var self = this;
			this.isLoading = true;

			let userRoles = await this.axios.get(this.$config.api + 'userRole')
			this.userRoles = userRoles.data.userRole;

			this.axios.get(this.$config.api + 'article/' + contentID + '?loadChangesLog=0&include=articleVariant.assignee,articleVariantGalleryAsset.asset')
				.then((response) => {

					// prepare assignee field for multiselect
					response.data.variants.forEach(variant => {
						if(variant.assignee != null) {

							/*
							let foundAssignee = this.userRoles.find((role) => role.id == parseInt(variant.assignee.userRole));

							if(foundAssignee) {
								variant.assignee.customLabel = variant.assignee.person.lastname + ' ('+ (foundAssignee && typeof foundAssignee != 'undefined' ? foundAssignee.name : '-') + ')';

							} else {
								variant.assignee = null;
							}
							*/

							// get userRole for this assignee
							let assigneeUserRole = this.userRoles.find((role) => role.id == parseInt(variant.assignee.userRole));

							// set custom label for this assignee ("Nachname (userRoleName)"")
							variant.assignee.customLabel = variant.assignee.person.lastname + ' ('+ (assigneeUserRole && typeof assigneeUserRole != 'undefined' ? assigneeUserRole.name : '-') + ')';

						}
					})

					this.content = response.data;

					// console.log("typ: ", self.content.type);

					response.data.categories.forEach((cat) => {
						this.contentCategories.push(cat.category);
					})

					response.data.topics.forEach((topic) => {
						this.contentTopics.push(topic.topic);
					})

					this.fetchMandatoryData();

				})

		},

		fetchMandatoryData() {

			this.isLoading = true;
			var self = this;

			function getUsers() {
				return self.axios.get(self.$config.api + 'user/contentPoolAssignees')
			}
			function getData() {
				return self.axios.get(self.$config.api + 'multi?calls[topics]=articleTopic&calls[categories]=articleCategory&calls[channels]=channel')
			}

			// make the request
			this.axios.all([getUsers(), getData()])

				.then(self.axios.spread(function (users, data) {

					self.categories = data.data.categories.articleCategory;
					self.topics = data.data.topics.articleTopic;
					self.channels = data.data.channels.channel;

					// self.users = users.data.user;

					let usersArr = [];
					users.data.user.forEach(u => {
						usersArr.push(
							{
							...u,
							customLabel: u.person.lastname + ' ('+u.userRole.name+')'
							}
						)
					})

					// order users by lastName
					usersArr.sort(function (a, b) {

					  if (a.person.lastname.toLowerCase() < b.person.lastname.toLowerCase()) {
					    return -1;
					  }
					  if (a.person.lastname.toLowerCase() > b.person.lastname.toLowerCase()) {
					    return 1;
					  }

					  return 0;

					});

					self.users = usersArr;


					// console.log(self.users);

					self.isLoading = false;

				})).catch(function(error) {
					self.isLoading = false;
					console.log('Error: ', error.message);
				});


		},


	}

}

</script>

<style scoped>

	ul.tabNav {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		list-style-type: none;
		flex: 0 1 auto;
	}
	ul.tabNav li.item {
		padding: 0;
	    margin: 0;
	    line-height: 24px;
		overflow: hidden;
	}
	ul.tabNav li.item a {
	    padding: 13px 17px;
	    border-radius: 0;
	    border-top-left-radius: 3px;
	    border-top-right-radius: 3px;
	    text-transform: uppercase;
	    color: #515159;
	    border: none;
	    -webkit-transition: background-color .3s ease;
	    transition: background-color .3s ease;
	    align-items: center;
	    display: flex;
	    justify-content: center;
	    margin-bottom: -1px;
	    vertical-align: top;
		white-space: nowrap;
		font-size: 13px;
	}
	ul.tabNav li.item a:hover,
	ul.tabNav li.item.is-active a {
		color: #000;
		background: #fff;
		font-weight: 500;
	}
	ul.tabNav li.item:not(.is-active) a:hover {
		background: rgba(255,255,255,.5);
	}
	ul.tabNav li.is-disabled a {
		background: none !important;
		color: #cdcdd2;
		cursor: default;
	}
	ul.tabNav li.is-disabled a:hover {
		background: none !important;
		color: #aaa;
		font-weight: normal;
	}


	>>> .contentPoolContent >>> .tabs .tab-list li.is-disabled a {
		color: #aaa !important;
	}
	>>> .tabContentSection {
		background: #fff;
		padding: 25px 30px;
		margin: 0;
	}
	>>> .tabContentSection.comments {
		padding: 0;
	}
	>>> .tabContentSectionBlock {
		padding: 0 30px 20px 30px;
		margin: 0 -30px 0 -30px;
	}
	>>> .tabContentSectionBlock:not(:first-child) {
		padding: 20px 30px;
		border-top: 1px solid #ddd;
	}


	>>> label span .mandatory {
		color: red;

	}

</style>
